import { RouteLocationNormalized } from 'vue-router'

import { useCurUser } from '@/composables/useCurUser'
import enums from '@/plugins/enums'
import { RequestData } from '@/types/curRequest'

export function useDashboardRedirect() {
  const { hasRole } = useCurUser()

  function getRedirect(to: RouteLocationNormalized, requests: RequestData[]) {
    const isBorrowerAndCantCreateRequests = hasRole('borrower') && !hasRole('submitter')
    
    if (requests.length === 0) {
      return getEmptyStateRedirect(to)
    }

    if (requests.length === 1 && isBorrowerAndCantCreateRequests) {
      return getSingleRequestRedirect(requests[0])
    }

    return true
  }

  function getEmptyStateRedirect(to: RouteLocationNormalized) {
    if (hasRole('submitter', 'cat')) {
      return { name: 'catalog', query: to.query }
    }

    if (hasRole('submitter', 'ers', true)) {
      return { name: 'ers', query: to.query }
    }

    if (hasRole('submitter', 'oepc', true)) {
      return { name: 'oepc.request', query: to.query }
    }

    if (hasRole('submitter', 'dvm', true) || hasRole('submitter', 'ovm', true)) {
      return { name: 'valuation.request', query: to.query }
    }

    return true
  }

  function getSingleRequestRedirect(row: RequestData) {
    const { valuation_type, valuation_request_ref, borrower, is_borrower_submitted } = row

    const baseQuery = { valuation_request_ref }

    switch (valuation_type) {
      case enums.modules.DVM:
      case enums.modules.OVM: {
        const suffix = borrower?.is_self && is_borrower_submitted ? 'request' : 'borrower'
        return { name: `valuation.${suffix}`, query: baseQuery }
      }
      case enums.modules.ERS:
        return { name: 'ers.request', query: baseQuery }
      case enums.modules.OEPC:
        return { name: 'oepc.request', query: baseQuery }
      default:
        return true
    }
  }

  return {
    getRedirect,
  }
}
